import { useState } from 'react'

import CheckBox from 'ageas-react-component-checkbox'

import {
  ActionsCell,
  ActionsHeader,
  ButtonContainer,
  Cell,
  Header,
  IdCell,
  IdHeader,
  Row,
  Table,
  TableContainer,
  Title,
} from '../../Components/AnimalInsuranceTable/styles'
import { Minus, Plus } from '../../Components/Icons'
import { usePolicyholderDetailsStore } from '../../Stores/policyholderDetailsStore'
import {
  LegalConsentsStore,
  useConsentsStore,
} from '../../Stores/useConsentsStore'
import { useResumeStore } from '../../Stores/useResumeStore'
import { t } from '../../i18n'

export const Consents = () => {
  const { policyholderDetailsSelected } = usePolicyholderDetailsStore()
  const [expanded, setExpanded] = useState(true)
  const { consents, updateConsent } = useConsentsStore()
  const { disabledStepsByResume } = useResumeStore()

  const [checkboxConsents, setCheckboxConsents] = useState<
    LegalConsentsStore[]
  >(
    consents.map((item) => ({
      ...item,
      answer: item.consentAnswerDescription === 'True',
    })),
  )

  return (
    <>
      <Title>{t('pages.step6.consents')}</Title>
      <TableContainer>
        <Table>
          <thead>
            <Row>
              <IdHeader></IdHeader>
              <Header>{t('table.name')}</Header>
              <Header>{t('table.vatNumber')}</Header>
              <ActionsHeader></ActionsHeader>
            </Row>
          </thead>
          <tbody>
            <Row>
              <IdCell />
              <Cell>
                <div className="owner-data">{t('pages.step7.owner')}</div>
                <label className="label">
                  {policyholderDetailsSelected?.name}
                </label>
              </Cell>
              <Cell>
                <label className="label">
                  {policyholderDetailsSelected?.vatNumber}
                </label>
              </Cell>
              <ActionsCell>
                <ButtonContainer onClick={() => setExpanded((prev) => !prev)}>
                  {expanded ? (
                    <Minus color="#333" size={24} />
                  ) : (
                    <Plus color="#333" size={24} />
                  )}
                </ButtonContainer>
              </ActionsCell>
            </Row>
            {expanded && (
              <Row>
                <Cell colSpan={4}>
                  <div className="container">
                    <div className="row">
                      {checkboxConsents.map((item, index) => (
                        <div
                          className="col"
                          key={`${item.legalConsentCode}+${index}`}
                        >
                          <CheckBox
                            id={item.legalConsentCode}
                            key={`${item.legalConsentCode}+${index}`}
                            required={item.mandatory}
                            value={item.answer ? '1' : '0'}
                            label={''}
                            readOnly={disabledStepsByResume.step6}
                            onValueChanged={(key: string, value: string) => {
                              updateConsent({
                                ...item,
                                answer: value === '1',
                              })
                              setCheckboxConsents(
                                checkboxConsents.map((consent) => {
                                  if (
                                    consent.legalConsentCode ===
                                    item.legalConsentCode
                                  ) {
                                    return {
                                      ...item,
                                      answer: value === '1',
                                    }
                                  }

                                  return consent
                                }),
                              )
                            }}
                          />
                          <p className="consents-container">
                            <b>{item.legalConsentTitle}. </b>
                            {item.legalConsentLongText}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                </Cell>
              </Row>
            )}
          </tbody>
        </Table>
      </TableContainer>
    </>
  )
}
